<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label for="practice">{{ 'layout.configurations.careerPath.addCareerPath.practice' | translate }}</label>
    <p-dropdown
      id="practice"
      formControlName="practice"
      [options]="practiceOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'layout.configurations.careerPath.addCareerPath.selectPractice' | translate"
      styleClass="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('practice') }"
      [emptyMessage]="'layout.configurations.careerPath.addCareerPath.noPracticesAvailable' | translate"
      [showClear]="true">
    </p-dropdown>
    <div *ngIf="isInvalid('practice')" class="text-red-600">{{ errorMessages['practice'] | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="name">{{ 'layout.configurations.careerPath.addCareerPath.name' | translate }}</label>
    <input
      id="name"
      formControlName="name"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.careerPath.addCareerPath.name' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('name') }" />
    <div *ngIf="isInvalid('name')" class="text-red-600">{{ errorMessages['name'] | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="numberOfLevels">{{ 'layout.configurations.careerPath.addCareerPath.numberOfLevels' | translate }}</label>
    <p-inputNumber
      id="numberOfLevels"
      inputId="integeronly"
      formControlName="numberOfLevels"
      [placeholder]="'layout.configurations.careerPath.addCareerPath.numberOfLevels' | translate"
      styleClass="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('numberOfLevels') }" />
    <div *ngIf="isInvalid('numberOfLevels')" class="text-red-600">
      {{ errorMessages['numberOfLevels'] | translate }}
    </div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check" [label]="'layout.configurations.careerPath.addCareerPath.save' | translate"></p-button>
  </div>
</form>
